module.exports = (__parcel__import__("5qwQB")).then(() => parcelRequire('fyWP3'));